import h from "./html";

import { Cog, Calendar, Plus } from "./icons";

function Link({ to }: { to: string }, ...children: Array<unknown>) {
  const pathname = h.pathnameState();
  const selected = h.derive(() => pathname.val === to);

  return (
    <a
      className={() =>
        `h-20 sm:h-14 text-lg flex items-center hover:bg-fairy-500 rounded-md p-4 sm:flex-row flex-col ${selected.val ? "bg-fairy-500 cursor-default" : ""}`
      }
      href={to}
      onclick={(ev: MouseEvent) => {
        ev.preventDefault();
        pathname.val = to;
      }}
    >
      {children}
    </a>
  );
}

export default function Sidebar() {
  return (
    <div className="sm:w-60 self-stretch bg-fairy-600 text-fairy-50 flex flex-row sm:flex-col p-2 justify-center gap-2">
      <h1 className="mb text-3xl font-bold p-4 text-amber-300 hidden sm:block">
        Polyday
      </h1>
      <Link to="/">
        <Calendar className="size-12 sm:size-6 sm:mr-2" />
        <div className="self-center text-sm sm:text-base">Agenda</div>
      </Link>
      <Link to="/event/new">
        <Plus className="size-12 sm:size-6 sm:mr-2" />
        <div className="self-center text-sm sm:text-base">New event</div>
      </Link>
      <div className="hidden sm:block sm:grow" />
      <Link to="/settings">
        <Cog className="size-12 sm:size-6 sm:mr-2" />
        <div className="self-center text-sm sm:text-base">Settings</div>
      </Link>
    </div>
  );
}
